import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link } from 'react-router-dom';
import SglContext from '../SglContext';
import cartIcon from '../images/shopping-cart.png';
import productIcon from '../images/product-placeholder.png'
import './SglCart.css';

const getJSONFromStorage = (storage_key) => {
  let storage_value = localStorage.getItem(storage_key)
  if (!storage_value) {
    return null
  } else {
    try {
      return JSON.parse(storage_value)
    } catch (e) {
      return null
    }
  }
}

const SglCart = () => {
  const [cartItems, setCartItems] = useState([]);
  const [cartShow, setCartShow] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [itemCount, setItemCount] = useState(0);
  const cartRef = useRef(null);
  const Sgl = useContext(SglContext);

  const webservice_url = Sgl.sglApiUrl;

  // Load cart data from localStorage
  const loadCartData = () => {
    const selectedShowfees = getJSONFromStorage('selected_showfees') || [];
    const selectedShowfeesShow = localStorage.getItem('selected_showfees_show') || '';
    
    setCartItems(selectedShowfees);
    setCartShow(selectedShowfeesShow);
    
    // Calculate total quantity
    const totalQty = selectedShowfees.reduce((total, item) => total + parseInt(item.quantity || 0), 0);
    setItemCount(totalQty);
  };

  // Update cart when localStorage changes
  useEffect(() => {
    loadCartData();
    
    // Listen for storage changes
    const handleStorageChange = () => {
      loadCartData();
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Custom event for cart updates within the same tab
    window.addEventListener('cartUpdated', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('cartUpdated', handleStorageChange);
    };
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cartRef.current && !cartRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const removeProduct = (sgl_id) => {
    const updatedItems = cartItems.filter(item => item.showfees_id !== sgl_id);
    
    // Update localStorage
    localStorage.setItem('selected_showfees', JSON.stringify(updatedItems));
    
    if (updatedItems.length === 0) {
      localStorage.removeItem('selected_showfees_show');
      localStorage.removeItem('selected_showfees_showid');
    }
    
    // Trigger update event
    window.dispatchEvent(new Event('cartUpdated'));
    
    // Update local state
    setCartItems(updatedItems);
    const totalQty = updatedItems.reduce((total, item) => total + parseInt(item.quantity || 0), 0);
    setItemCount(totalQty);
  };

  const formatCurrency = (amount) => {
    if (amount == undefined || amount == '') {
      return '';
    }
    if (amount == 0) {
      return '$0.00';
    }
    return '$' + (amount && Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  };

  const calculateTotal = () => {
    return cartItems.reduce((total, item) => total + parseFloat(item.total_price || 0), 0);
  };

  const toggleCart = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="sgl-cart-container" ref={cartRef}>
      <div 
        className="cart-invoker" 
        onClick={toggleCart}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        <span className="cart-button">
          <img src={cartIcon} alt="Shopping Cart" />
        </span>
        {itemCount > 0 && (
          <span className="cart-badge">{itemCount}</span>
        )}
      </div>

      {isOpen && (
        <div 
          className="cart-dropdown"
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
        >
          <div className="cart-card">
            <div className="cart-header">
              <span>CART</span>
              {cartShow && (
                <div className="cart-show-name">{cartShow}</div>
              )}
            </div>
            
            {cartItems.length > 0 ? (
              <>
                <div className="cart-body">
                  {cartItems.map((item, index) => (
                    <div key={item.showfees_id || index} className="cart-media" data-product-id={item.showfees_id}>
                      <div className="cart-image">
                        {item.featured_image ? (
                          <img 
                            src={
                              item.featured_image.on_cdn 
                                ? item.featured_image.filepath 
                                : `${webservice_url}${item.featured_image.filepath}${item.featured_image.thumbnail}`
                            } 
                            alt={item.supplies_name}
                          />
                        ) : (
                          <img src={productIcon} alt="Product placeholder" />
                        )}
                      </div>
                      <div className="cart-media-body">
                        <div className="cart-first-row">
                          <span className="cart-product-name">{item.supplies_name}</span>
                          <button 
                            type="button" 
                            className="cart-close" 
                            onClick={() => removeProduct(item.showfees_id)}
                          >
                            <span>×</span>
                          </button>
                        </div>
                        <span className="cart-second-row">
                          <label>{item.quantity} x </label>
                          <span>{formatCurrency(item.unit_price)}</span>
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
                
                <div className="cart-footer">
                  <div className="cart-total">
                    <span>Order Total</span>
                    <span className="cart-total-cost">{formatCurrency(calculateTotal())}</span>
                  </div>
                  <div className="cart-checkout">
                    <Link to="/order-supplies/complete-order">Complete Order</Link>
                  </div>
                </div>
              </>
            ) : (
              <p className="cart-no-items">No items in the cart yet.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SglCart;